import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { Avatar, Button, Flex, Image, Label, Segment, Text,} from "@fluentui/react-northstar";
import { InfoIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons } from '@fluentui/react';
import { getAppConfig, getMeetingData, getAppSettings } from '../../../../api/publicapp-api';
import "./queue-limit.scss";
import { CommonHelper } from '../../../../helpers/common-helper';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";

interface IState {
    appConfigs: any;
    appSettings: any;
    ancora: string;
    meetingData: any;
    loader: any;
}

export type QueueLimitProps = {} & RouteComponentProps & WithTranslation;

class QueueLimit extends React.Component<QueueLimitProps, IState> {
    private localize: TFunction;

    constructor(props: QueueLimitProps) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        let pathname = window.location.pathname;

        this.state = {
            appConfigs: null,
            appSettings: null,
            ancora: pathname.split("/")[2],
            meetingData: [],
            loader: true,
        }
    }


    /**
    * Used to initialize this component.
    */
    public async componentDidMount() {
        setTimeout(() => this.setState({ loader: false }), 2500);

        this.getAppConfig();
        this.getAppSettings();
        this.getMeetingData();
    }

    /**
     * Get App Configs
     * */
    private async getAppConfig() {

        let response = await getAppConfig();
        if (response.status === 200 && response.data) {
            this.setState({
                appConfigs: response.data,
            });
        }
    };

    /**
     * Get App Settings
     * */
    private async getAppSettings() {
        let response = await getAppSettings();
        if (response.status === 200 && response.data) {
            this.setState({
                appSettings: response.data,
            });
        }
    };

    /**
    * Get meeting data.
    */
    public async getMeetingData() {
        let response = await getMeetingData(this.state.ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingData: response.data,
            });
        }
    }

    /**
    * Render header.
    */
    public renderHeader() {
        return (
            this.state.appConfigs ?
                <Flex>
                    <Flex.Item>
                        <Flex className="logo" gap="gap.small" vAlign="center">
                            <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                            <Text weight="semibold" content={this.localize("BalcaoVirtual")} size="medium" />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item grow>
                        <Flex hAlign="center" vAlign="center">
                            <Label className="headerLabel" content={this.state.appConfigs.tribunal} />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item push>
                        <Flex gap="gap.smaller" vAlign="center" className="sobre" onClick={() => window.open("https://balcaovirtual.studio365.io/", "_blank")}>
                            <InfoIcon outline />
                            <Text weight="light" content={this.localize("Sobre")} size="small" />
                        </Flex>
                    </Flex.Item>
                </Flex>
                :
                <React.Fragment />
        )
    }

    /**
    * Render body.
    */
    public renderBody() {
        return (
            <React.Fragment>
                <Flex gap="gap.medium" className="card">
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!this.state.loader} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={this.state.loader}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={this.localize("BemVindo")} />

                                    <Flex>
                                        <Flex fill column>

                                            <Flex gap="gap.large">
                                                <Label
                                                    className="mensagem-label"
                                                    content={(
                                                        <Flex column>
                                                            <Text
                                                                align="center"
                                                                size="medium"
                                                                content={
                                                                    <span>{this.localize("LimiteFilaMsg")}&nbsp;
                                                                        <span style={{ fontWeight: "bold" }}>{this.state.meetingData.queueLimit}</span>.
                                                                        <p>{this.localize("TenteNovamente")}</p>
                                                                    </span>
                                                                }
                                                            />
                                                        </Flex>
                                                    )}
                                                />
                                            </Flex>

                                            <Flex gap="gap.small" styles={{ marginTop: "15px !important" }}>

                                                {this.state.appSettings && this.state.appSettings.ajudaComoFunciona &&
                                                    <Button content={this.localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(this.state.appSettings.ajudaComoFunciona), "_blank")} />
                                                }

                                                {this.state.appSettings && this.state.appSettings.ajudaPerguntasFrequentes &&
                                                    <Button content={this.localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(this.state.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                                }

                                            </Flex>

                                        </Flex>
                                        <Flex.Item align="end" className="atendimento-indisponivel">
                                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/fora-horario.svg" className="fora-horario-img" />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
                {this.state.meetingData.bookingsUrl &&
                    <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                        <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                        <Flex.Item grow>
                            <Segment
                                hidden={this.state.loader}
                                className="dialog2 dialog"
                                content={
                                    <Flex gap="gap.large" column>
                                        <Text className="header-text" content={this.localize("Agendamento")} />

                                        <Flex gap="gap.smaller" column>
                                            {this.state.appConfigs && this.state.appConfigs.agendamentoQueueText == "" &&
                                                <Text weight="light" size="medium" content={this.localize("AgendamentoDescricao")} />
                                            }

                                            {this.state.appConfigs && this.state.appConfigs.agendamentoQueueText != "" &&
                                                <Text weight="light" size="medium" content={this.state.appConfigs.agendamentoQueueText} />
                                            }

                                            <Button content={this.localize("FazerAgendamento")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(this.state.meetingData.bookingsUrl), "_blank")} />
                                        </Flex>
                                    </Flex>
                                }
                            />
                        </Flex.Item>
                    </Flex>
                }
            </React.Fragment>
        )
    }

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <div className="atendimento-indisponivel">
                    <div className="header">
                        <Segment
                            className="headerLine"
                            inverted
                            content={this.renderHeader()}
                        />
                    </div>
                    <div className="body">
                        {this.renderBody()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const queueLimitWithTranslation = withTranslation()(QueueLimit);
export default queueLimitWithTranslation;